import { Directive, TemplateRef, ViewContainerRef, effect, inject, input } from '@angular/core';

/**
 * Structural directive that destroys and recreates the host element whenever the bound value changes.
 * Use this when a component retains internal state (e.g. scroll position) that must be reset on input change.
 *
 * Usage: <some-component *sbRecreateOnChange="value" />
 */
@Directive({
  selector: '[sbRecreateOnChange]',
})
export class RecreateOnChangeDirective {
  readonly sbRecreateOnChange = input.required<unknown>();

  private vcr = inject(ViewContainerRef);
  private templateRef = inject(TemplateRef<unknown>);

  constructor() {
    // effect() only re-runs when the signal value changes (Object.is equality),
    // so this naturally skips unnecessary recreations.
    effect(() => {
      this.sbRecreateOnChange();
      this.vcr.clear();
      this.vcr.createEmbeddedView(this.templateRef);
    });
  }
}
